import { VariableLocation } from 'craft/types';

export enum StateProviderType {
  UserTraits = 'UserTraits',
  URL = 'URL',
}

interface StateProvider {
  resolver: {
    type: StateProviderType;
    scope?: string;
    scopeTrait?: string;
    traits?: string[];
    key?: string;
  };
}

interface Variable {
  id: string;
  type: string;
  name: string;
  fallback?: string;
}

/* eslint-disable no-param-reassign */
export const insertStateForVariable = (
  variable: Variable,
  providers: Record<string, StateProvider>,
  location: VariableLocation,
) => {
  // get provider if we already have one for this variable
  let providerId = Object.keys(providers).find((key: string) => {
    const { resolver } = providers[key];
    if (!resolver || !resolver.traits) {
      return false;
    }

    if (
      variable.type === 'url' &&
      resolver.type === StateProviderType.URL &&
      resolver.key === variable.name
    ) {
      return true;
    }

    if (
      variable.type === 'user' &&
      resolver.type === StateProviderType.UserTraits &&
      resolver.traits.includes(variable.name)
    ) {
      return true;
    }

    return false;
  });

  // otherwise insert it
  if (!providerId) {
    // provider ID can just be a modified version of variable ID for now
    providerId = `p-${variable.id}`;

    if (variable.type === 'url') {
      providers[providerId] = {
        resolver: {
          type: StateProviderType.URL,
          key: variable.name,
        },
      };
    } else {
      // default variable type is user traits, RTE depends on this to work!
      providers[providerId] = {
        resolver: {
          type: StateProviderType.UserTraits,
          traits: [variable.name],
        },
      };
    }
  }

  // return new variable definition
  return {
    providerId,
    location,
    fallback: variable.fallback,
  };
};
